import { __decorate } from "tslib";
import { TaskStatus, NodeType } from '../../Types/TaskStatus';
import { BindingHelper } from '../NodeExecutor';
import { NodeExecutorMetadata } from '../NodeMetadata';
/**
 * 设置黑板值动作执行器
 *
 * 设置黑板中的变量值
 */
let SetBlackboardValue = class SetBlackboardValue {
    execute(context) {
        const { runtime } = context;
        const key = BindingHelper.getValue(context, 'key', '');
        const value = BindingHelper.getValue(context, 'value');
        if (!key) {
            return TaskStatus.Failure;
        }
        runtime.setBlackboardValue(key, value);
        return TaskStatus.Success;
    }
};
SetBlackboardValue = __decorate([
    NodeExecutorMetadata({
        implementationType: 'SetBlackboardValue',
        nodeType: NodeType.Action,
        displayName: '设置黑板值',
        description: '设置黑板中的变量值',
        category: 'Action',
        configSchema: {
            key: {
                type: 'string',
                default: '',
                description: '黑板变量名'
            },
            value: {
                type: 'object',
                description: '要设置的值',
                supportBinding: true
            }
        }
    })
], SetBlackboardValue);
export { SetBlackboardValue };
//# sourceMappingURL=SetBlackboardValue.js.map